/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RemoveGroupEmergencyEmailRequest
 */
export interface RemoveGroupEmergencyEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof RemoveGroupEmergencyEmailRequest
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof RemoveGroupEmergencyEmailRequest
     */
    group_id: string;
    /**
     * 
     * @type {string}
     * @memberof RemoveGroupEmergencyEmailRequest
     */
    email: string;
}

/**
 * Check if a given object implements the RemoveGroupEmergencyEmailRequest interface.
 */
export function instanceOfRemoveGroupEmergencyEmailRequest(value: object): value is RemoveGroupEmergencyEmailRequest {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('group_id' in value) || value['group_id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function RemoveGroupEmergencyEmailRequestFromJSON(json: any): RemoveGroupEmergencyEmailRequest {
    return RemoveGroupEmergencyEmailRequestFromJSONTyped(json, false);
}

export function RemoveGroupEmergencyEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemoveGroupEmergencyEmailRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'group_id': json['group_id'],
        'email': json['email'],
    };
}

export function RemoveGroupEmergencyEmailRequestToJSON(json: any): RemoveGroupEmergencyEmailRequest {
    return RemoveGroupEmergencyEmailRequestToJSONTyped(json, false);
}

export function RemoveGroupEmergencyEmailRequestToJSONTyped(value?: RemoveGroupEmergencyEmailRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'group_id': value['group_id'],
        'email': value['email'],
    };
}

